const c="#ff69b4",f="#ffffcc",e="#eeeeee",d="#cccccc",o="#c0c0c0",r="#666666",t="#fdfdfd",a="gray";export{r as DARKER_GRAY,o as DARK_GRAY,a as GRAY,e as LIGHTER_GRAY,d as LIGHT_GRAY,c as RED,t as WHITE,f as YELLOW};
